import { render, staticRenderFns } from "./WatchlistItem.vue?vue&type=template&id=40af4378&"
import script from "./WatchlistItem.vue?vue&type=script&lang=js&"
export * from "./WatchlistItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports